'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-color: #ffffff;\n  overflow: hidden;\n  white-space: nowrap;\n  font-family: \'Nunito Sans\';\n  z-index: 1000;\n'], ['\n  background-color: #ffffff;\n  overflow: hidden;\n  white-space: nowrap;\n  font-family: \'Nunito Sans\';\n  z-index: 1000;\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  list-style-type: none;\n  padding-inline-start: 0;\n  padding-left: 0px;\n  margin: 4px 0;\n'], ['\n  list-style-type: none;\n  padding-inline-start: 0;\n  padding-left: 0px;\n  margin: 4px 0;\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin: 0px;\n  position: relative;\n  &:hover {\n    background-color: #f6f6f6;\n    a {\n      color: #6e0ad6;\n    }\n  }\n\n  ', '\n'], ['\n  margin: 0px;\n  position: relative;\n  &:hover {\n    background-color: #f6f6f6;\n    a {\n      color: #6e0ad6;\n    }\n  }\n\n  ', '\n']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      &:after {\n        box-sizing: content-box;\n        content: attr(data-counter);\n        position: absolute;\n        right: 16px;\n        top: calc(50% - 8px);\n        background: #f78323;\n        width: 24px;\n        height: 12px;\n        border-radius: 40%;\n        color: #fff;\n        font-size: 9px;\n        text-align: center;\n        padding: 3px 0;\n        pointer-events: none;\n      }\n    '], ['\n      &:after {\n        box-sizing: content-box;\n        content: attr(data-counter);\n        position: absolute;\n        right: 16px;\n        top: calc(50% - 8px);\n        background: #f78323;\n        width: 24px;\n        height: 12px;\n        border-radius: 40%;\n        color: #fff;\n        font-size: 9px;\n        text-align: center;\n        padding: 3px 0;\n        pointer-events: none;\n      }\n    ']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: none;\n  ', '\n'], ['\n  display: none;\n  ', '\n']),
  _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n    display: initial;\n  '], ['\n    display: initial;\n  ']),
  _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  height: 1px;\n  overflow: hidden;\n  border-top: 1px solid #d2d2d2;\n  margin: 4px 0;\n  ', '\n'], ['\n  height: 1px;\n  overflow: hidden;\n  border-top: 1px solid #d2d2d2;\n  margin: 4px 0;\n  ', '\n']),
  _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n      margin-left: 16px;\n      margin-right: 16px;\n    '], ['\n      margin-left: 16px;\n      margin-right: 16px;\n    ']),
  _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n  ', ' cursor: pointer;\n  margin: 0px;\n  padding: 10px 0px;\n  padding-left: 24px;\n  font-weight: normal;\n  font-size: 14px !important;\n  display: block;\n  text-align: left;\n  ', '\n'], ['\n  ', ' cursor: pointer;\n  margin: 0px;\n  padding: 10px 0px;\n  padding-left: 24px;\n  font-weight: normal;\n  font-size: 14px !important;\n  display: block;\n  text-align: left;\n  ', '\n']),
  _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n    padding-left: 16px;\n    font-size: 16px !important;\n  '], ['\n    padding-left: 16px;\n    font-size: 16px !important;\n  ']),
  _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 16px;\n  margin-right: 16px;\n'], ['\n  margin-left: 16px;\n  margin-right: 16px;\n']); /* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */

var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _View = require('../../atoms/View');
var _View2 = _interopRequireDefault(_View);
var _LinkMenu = require('../../atoms/LinkMenu');
var _LinkMenu2 = _interopRequireDefault(_LinkMenu);
var _LoggedUserLinkMenu = require('../../molecules/LoggedUserLinkMenu');
var _LoggedUserLinkMenu2 = _interopRequireDefault(_LoggedUserLinkMenu);
var _medias = require('../../../util/medias');
var _medias2 = _interopRequireDefault(_medias);
var _font = require('../../../util/font');
var _lurker = require('../../../util/lurker');
var _staticUrl = require('../../../config/staticUrl');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Nav = _styledComponents2.default.nav(_templateObject);
var Ul = _styledComponents2.default.ul(_templateObject2);
var Li = _styledComponents2.default.li(_templateObject3, function (props) {
  return props.hasBadge && (0, _styledComponents.css)(_templateObject4);
});
var MobileSection = (0, _styledComponents2.default)(_View2.default)(_templateObject5, _medias2.default.medium(_templateObject6));
var Divider = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.withHorizontalMargins && (0, _styledComponents.css)(_templateObject8);
});
var LinkMenuStyled = (0, _styledComponents2.default)(_LinkMenu2.default)(_templateObject9, _font.fontH3, _medias2.default.medium(_templateObject10));
var UserLinkMenuStyled = (0, _styledComponents2.default)(_LoggedUserLinkMenu2.default)(_templateObject11);
var waitEvent = function waitEvent(event) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  callback();
  if (!event.metaKey && !event.ctrlKey) {
    event.preventDefault();
    var url = event.target.getAttribute('href');
    setTimeout(function () {
      location.href = url;
    }, 0);
  }
};
var SubMenu = function (_React$PureComponent) {
  (0, _inherits3.default)(SubMenu, _React$PureComponent);
  function SubMenu(props) {
    (0, _classCallCheck3.default)(this, SubMenu);
    var _this = (0, _possibleConstructorReturn3.default)(this, (SubMenu.__proto__ || (0, _getPrototypeOf2.default)(SubMenu)).call(this, props));
    _this.state = {
      urls: {}
    };
    return _this;
  }
  (0, _createClass3.default)(SubMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        urls: (0, _extends3.default)({}, (0, _staticUrl.getUrls)())
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        isLogged = _props.isLogged,
        isDropDown = _props.isDropDown,
        userName = _props.userName,
        profilePictureUrl = _props.profilePictureUrl,
        notifications = _props.notifications,
        userProfileLink = _props.userProfileLink;
      var _state$urls = this.state.urls,
        chat = _state$urls.chat,
        meusAnuncios = _state$urls.meusAnuncios;
      var accountLink = void 0;
      if (isLogged === true) {
        if (!isDropDown) {
          accountLink = _react2.default.createElement(UserLinkMenuStyled, {
            href: _staticUrl.minhaConta,
            userName: userName,
            profilePictureUrl: profilePictureUrl
          });
        } else {
          accountLink = _react2.default.createElement(LinkMenuStyled, {
            href: _staticUrl.minhaConta
          }, 'Meu cadastro');
        }
      } else if (isLogged === false) {
        accountLink = _react2.default.createElement(LinkMenuStyled, {
          href: _staticUrl.login
        }, 'Entrar');
      } else {
        accountLink = _react2.default.createElement(LinkMenuStyled, {
          href: _staticUrl.minhaConta
        }, 'Minha Conta');
      }
      return _react2.default.createElement(Nav, this.props, _react2.default.createElement(Ul, null, !isDropDown && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(Li, null, accountLink), isLogged && _react2.default.createElement(Divider, null)), _react2.default.createElement(MobileSection, null, _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: _staticUrl.busca,
        onClick: function onClick(ev) {
          return waitEvent(ev, function () {
            return (0, _lurker.lurkerClickEvt)('header_buscar');
          });
        }
      }, 'Buscar'))), !isDropDown && _react2.default.createElement(Divider, null), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: meusAnuncios
      }, 'Meus an\xFAncios')), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: chat
      }, 'Chat')), isLogged === true && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(Li, {
        hasBadge: notifications > 0,
        'data-counter': notifications > 99 ? '99+' : notifications
      }, _react2.default.createElement(LinkMenuStyled, {
        href: _staticUrl.notificacoes,
        onClick: function onClick(ev) {
          return waitEvent(ev, function () {
            return (0, _lurker.lurkerClickEvt)('header_notificacoes', {
              data: {
                has_badge: notifications > 0 ? 'true' : 'false'
              }
            });
          });
        }
      }, 'Notifica\xE7\xF5es')), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: _staticUrl.favoritos,
        onClick: function onClick(ev) {
          return waitEvent(ev, function () {
            return (0, _lurker.lurkerClickEvt)('header_favoritos');
          });
        }
      }, 'Favoritos')), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: _staticUrl.meuPlano
      }, 'Plano profissional')), isDropDown && _react2.default.createElement(Divider, {
        withHorizontalMargins: true
      }), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: userProfileLink
      }, 'Meu perfil')), isDropDown && _react2.default.createElement(Li, null, accountLink), _react2.default.createElement(Divider, {
        withHorizontalMargins: isDropDown
      }), _react2.default.createElement(Li, null, _react2.default.createElement(LinkMenuStyled, {
        href: _staticUrl.sair
      }, 'Sair')))));
    }
  }]);
  return SubMenu;
}(_react2.default.PureComponent);
SubMenu.defaultProps = {
  isOpen: true,
  isDropDown: false,
  notifications: 0
};
SubMenu.propTypes = {
  isOpen: _propTypes2.default.bool,
  isDropDown: _propTypes2.default.bool,
  isLogged: _propTypes2.default.bool,
  userName: _propTypes2.default.string,
  profilePictureUrl: _propTypes2.default.string,
  userProfileLink: _propTypes2.default.string,
  notifications: _propTypes2.default.number
};
exports.default = SubMenu;